// This only ensures that building with valid UUID is passed in the URL
export const isBuildingRegex = "^/(?:hosted/)?places/buildings/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$";
